exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div:first-child {\r\n  margin-top: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/roteiro-interno/roteiro-interno.component.css
// module id = ../../../../../src/app/roteiro/roteiro-interno/roteiro-interno.component.css
// module chunks = main